module.exports = __webpack_public_path__ + "static/media/siri04.642a3b3c.jpg";